import Api from "./Api";

export const getAllContract = async (params) =>
  Api().get(`contract`, { params });

export const getSubLicenseList = async (params) =>
  Api().get(`contract/sub-license-list`, { params });

export const saveSubLicenseService = async (payload) =>
  Api().post(`contract/save-sub-license-document`, payload);

export const saveLastStatementDue = async (payload) =>
  Api().post(`contract/last-statement-due`, payload);

export const saveLastStatementDueDate = async (payload) =>
  Api().post(`contract/last-statement-due-date`, payload);

export const saveItemInHistory = async (payload) =>
  Api().post(`contract/save-history`, payload);

export const setContractDelete = async (payload) =>
  Api().post(`contract/delete`, payload);

export const setContractRevert = async (payload) =>
  Api().post(`contract/revert`, payload);

export const getSingleContract = async (id) =>
  Api().get(`contract/single/${id}`);

export const saveContract = async (payload) =>
  Api().post(`contract/save`, payload);

export const GetContractTransactions = async (contract_id) =>
  Api().get(`/contract/transactions/${contract_id}`);

export const getAllMilestones = async (params) =>
  Api().get(`contract/milestones`, { params });

export const SaveContractMileStones = async (payload) =>
  Api().post(`/contract/milestones`, payload);

export const getAllBumpers = async (params) =>
  Api().get(`contract/bumpers`, { params });

export const SaveContractBumper = async (payload) =>
  Api().post(`/contract/bumpers`, payload);

export const getAvailableTrl = async (payload) =>
  Api().get(`contract/available-trl`, { params: payload });

export const getAvailableDateRange = async ({ movie_id }) =>
  Api().get(`contract/available-date-range`, { params: movie_id });

export const GetContractLogs = async (contract_id) =>
  Api().get(`contract/logs/${contract_id}`);

export const GetAcquiredTrl = async (payload) =>
  Api().post(`contract/acquired-trl`, payload);

export const GetSelectList = async (payload) =>
  Api().get(`contract/select-list`, payload);

export const contract_modification_issues = async (payload) =>
  Api().post(`contract/issues`, payload);

export const get_contract_territories_rights = async (params) =>
  Api().get(`contract/contract_territories_rights`, { params });
